// @flow
import * as React from 'react';
import { components, colors } from '@peachjar/components';

const { Modal } = components;
const { ButtonFlatLarge } = components.Buttons;

type Props = {|
  +closeModal: () => void,
  +videoTitle: string,
  +videoSrc: string,
|};

const VideoModal = ({ closeModal, videoTitle, videoSrc }: Props) => (
  <Modal width="sm" onBackdropClick={closeModal}>
    <Modal.Header color={colors.gold}>{videoTitle}</Modal.Header>
    <Modal.Body>
      <iframe
        title={videoTitle}
        width="100%"
        height="315px"
        src={videoSrc}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        style={{ paddingTop: '1rem' }}
      />
    </Modal.Body>
    <Modal.Footer>
      <ButtonFlatLarge onClick={closeModal} data-testid="click-closeVideoModal">
        Close
      </ButtonFlatLarge>
    </Modal.Footer>
  </Modal>
);

export default VideoModal;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-training/components/VideoModal.jsx